/* @flow */
export const HEARTBEAT_MS = 500;

export default (fn: Function, freq: number = HEARTBEAT_MS): Promise<void> =>
  new Promise(resolve =>
    (function heartbeat() {
      fn() ? resolve() : setTimeout(heartbeat, freq); // eslint-disable-line
    })()
  );
